import { SwaggerException } from '../web-api-client';

/**
 * Lỗi API đã được dịch sang thứ giao diện dùng được: một câu để hiện cho người dùng, và (nếu là lỗi
 * kiểm tra dữ liệu) danh sách lỗi theo từng trường để đánh dấu đúng ô nhập.
 */
export interface ApiError {
  status: number;
  message: string;
  fieldErrors: Record<string, string[]>;
}

const BY_STATUS: Record<number, string> = {
  401: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
  403: 'Bạn không có quyền thực hiện thao tác này.',
  404: 'Không tìm thấy dữ liệu. Có thể nó đã bị xóa.',
  429: 'Bạn thao tác quá nhanh. Vui lòng chờ một lát rồi thử lại.',
  500: 'Máy chủ gặp sự cố. Vui lòng thử lại sau.'
};

function firstMessage(fieldErrors: Record<string, string[]>): string | null {
  for (const messages of Object.values(fieldErrors)) {
    if (messages?.length) return messages[0];
  }

  return null;
}

export function toApiError(error: unknown): ApiError {
  if (error instanceof TypeError) {
    // fetch chỉ ném TypeError khi không gửi đi được: mất mạng, máy chủ chưa chạy, bị CORS chặn.
    return { status: 0, message: 'Không kết nối được tới máy chủ.', fieldErrors: {} };
  }

  if (!SwaggerException.isSwaggerException(error)) {
    return { status: 0, message: 'Đã xảy ra lỗi không mong muốn.', fieldErrors: {} };
  }

  const status = error.status;
  let payload: any = null;

  try {
    payload = error.response ? JSON.parse(error.response) : null;
  } catch {
    payload = null;
  }

  const fieldErrors: Record<string, string[]> = payload?.errors ?? {};

  const message =
    firstMessage(fieldErrors) ??
    payload?.detail ??
    BY_STATUS[status] ??
    payload?.title ??
    'Đã xảy ra lỗi không mong muốn.';

  return { status, message, fieldErrors };
}

/** Lấy thông báo cho một trường, không phân biệt hoa thường vì máy chủ trả về tên thuộc tính C#. */
export function fieldError(error: ApiError | null, field: string): string | undefined {
  if (!error) return undefined;

  const key = Object.keys(error.fieldErrors).find(name => name.toLowerCase() === field.toLowerCase());

  return key ? error.fieldErrors[key][0] : undefined;
}
